import { useContext } from 'react';
import { TenantContext } from '@trashlab/sitesapp/src/contexts/tenant-context';

export const useTenantContext = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenantContext must be used within a TenantProvider');
  }
  return context;
};
